import "core-js/modules/es6.array.find.js";
export default {
  computed: {
    budgetRecurrenceOptions: function budgetRecurrenceOptions() {
      return [{
        //  this.$t('general.total_time')
        label: this.$t('timeframe.week'),
        value: 1
      }, {
        label: this.$t('timeframe.month'),
        value: 2
      }];
    },
    budgetRecurrenceDaysOfWeekOptions: function budgetRecurrenceDaysOfWeekOptions() {
      return [{
        label: this.$t('days.sunday'),
        value: 0
      }, {
        label: this.$t('days.monday'),
        value: 1
      }, {
        label: this.$t('days.tuesday'),
        value: 2
      }, {
        label: this.$t('days.wednesday'),
        value: 3
      }, {
        label: this.$t('days.thursday'),
        value: 4
      }, {
        label: this.$t('days.friday'),
        value: 5
      }, {
        label: this.$t('days.saturday'),
        value: 6
      }];
    },
    budgetTypesOptions: function budgetTypesOptions() {
      return [{
        label: this.$t('general.no_budget'),
        value: 'none'
      }, {
        label: this.$t('general.time_budget'),
        value: 'time'
      }, {
        label: this.$t('general.monetary_budget'),
        value: 'monetary'
      }];
    }
  },
  methods: {
    budgetRecurrenceLabel: function budgetRecurrenceLabel(value) {
      var option = this.budgetRecurrenceOptions.find(function (option) {
        return option.value === value;
      }); // default visual value to month

      return option ? option.label : this.$t('timeframe.month');
    },
    budgetTypeLabel: function budgetTypeLabel(value) {
      var option = this.budgetTypesOptions.find(function (option) {
        return option.value === value;
      });
      return option ? option.label : '';
    },
    budgetRecurrenceDayOfWeek: function budgetRecurrenceDayOfWeek(value) {
      var option = this.budgetRecurrenceDaysOfWeekOptions.find(function (option) {
        return option.value === value;
      });
      return option ? option.label : '';
    }
  }
};